import * as types from "@/store/types";
import axios from "axios";

export default {
  async getQuestions({ commit }, params) {
    try {
      const { data } = await axios.post(`/api/web/questions`);
      commit(types.FETCH_QUESTIONS, { questions: data });

      let questions = data.data[2].subcategories[0].questions
      let random_questions = questions.filter(x => x.type_question.name === 'textarea-random')
      let question_index = Math.floor(Math.random() *random_questions.length);
      let selected_question = random_questions[question_index];

      let result_questions = questions.filter(x => x.type_question.name !== 'textarea-random')
      result_questions.push(selected_question);

      console.log(result_questions);
      data.data[2].subcategories[0].questions = result_questions;

      return data;

    } catch (e) {
      commit(types.FETCH_QUESTIONS_FAILURE);
      return null;
    }
  },

  async getTest({ commit }, params) {
    try {
      const { data } = await axios.get(`/api/web/quiz`);
      commit(types.FETCH_TEST, { test: data });
      return data;
    } catch (e) {
      commit(types.FETCH_TEST_FAILURE);
      return null;
    }
  },
};
